import { Component } from "@angular/core";
import { Broadcaster } from "../service/Broadcaster";
import { AlertService } from "./service/alert.service";
import { Alert } from "../class/alert/alert";


@Component({
    selector: "alert-comp",
    templateUrl: "html/alert.component.html",
    styleUrls: ["css/alert.component.css"],
    providers: [AlertService]
})
export class AlertComponent {
    message: string = "";

    constructor(private broadcaster: Broadcaster, public action: AlertService) { }
    ngOnInit() {
        this.broadcaster.on<any>("showAlert").subscribe((data: Alert) => {
            this.message = data.message;
            this.action.show(data);
        });
        this.action.onInit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/alert/alert.component.ts